module.exports = __webpack_public_path__ + "img/small_logo.2bcb1b2e.png";